import { Base } from '../base-component';

import './carousel-article-list-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from 'services/media-query.service';

export class CarouselArticleListItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/carousel-article-list-item/carousel-article-list-item.component.ts